<template>
  <div>
    <div v-if="!success && contract != null">
      <div class="vx-row">
        <div class="vx-col">
          <vx-card :title="contract.contract_type.name">
            <p class="mb-base">{{ contract.contract_type.description }}</p>

            <h4>Nieuw termijnbedrag:</h4>
            <money-format
              :value="contract.tailored_quote.recurring_amount"
              locale="nl"
              currency-code="EUR"
              :subunit-value="true"
            />
            <div v-if="contract.contract_type.id == 4" class="mt-base">
              <h4>{{ $t("Action.May_Title") }}</h4>
              <p>{{ $t("Action.May_Description") }}</p>

              <price-table :month-table="contract.current_prices" />
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mx-auto m-base">
          <vs-button color="primary" type="filled" @click="openConfirm()"
            >Ja, sluit dit contract af</vs-button
          >
        </div>
      </div>
    </div>
    <div v-if="success">
      <vs-alert color="success" title="Verstuurd" active="true">
        We hebben je verzoek binnengekregen om je contract aan te passen. Je
        ontvangt binnenkort een mail met je nieuwe contract.
      </vs-alert>
    </div>
  </div>
</template>

<script>
import axios from "../../axios";
import MoneyFormat from "vue-money-format";
import PriceTable from "../PriceTable.vue";
export default {
  props: ["id"],
  data() {
    return { success: false, possibleContractChanges: [] };
  },
  components: {
    MoneyFormat,
    PriceTable
  },
  computed: {
    contract() {
      return this.possibleContractChanges[0];
    }
  },
  async created() {
    await this.getPossibleContracts();
  },
  methods: {
    async getPossibleContracts() {
      this.loading = true;
      try {
        let res = await axios().get(
          `/api/contracts/${this.id}/possible_contract_changes`
        );
        this.possibleContractChanges = res.data;
      } catch (e) {
        this.showError(
          "Er is iets mis gegaan bij het ophalen van de data",
          false,
          e
        );
      } finally {
        this.loading = false;
      }
    },
    openConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Bevestigen`,
        text: "Weet je zeker dat je dit contract wil afsluiten?",
        accept: this.acceptAlert,
        acceptText: "Ja",
        cancelText: "Sluiten"
      });
    },
    async acceptAlert() {
      await axios().post(`/api/contracts/change_contract`, {
        contract_id: this.id,
        new_contract_type: this.contract.contract_type.name
      });
      this.success = true;
    }
  }
};
</script>

<style>
.con-vs-dialog {
  z-index: 53001;
}
</style>
